'use client';

import { ReactNode, createContext } from 'react';
import { ShopIds } from '@/utility/shopIds';

// A React context rather than a hydrated atom: context also reaches content streamed in
// Suspense boundaries. `null` without a provider (previews, Storybook): see useShopIds.
export const ShopIdsContext = createContext<ShopIds | null>(null);

export function ShopIdsProvider({ shopIds, children }: { shopIds: ShopIds; children: ReactNode }) {
  return <ShopIdsContext.Provider value={shopIds}>{children}</ShopIdsContext.Provider>;
}
